// Legacy color constants — preserved so existing imports keep working.
// Values are sourced from the refined palette in ./theme.js.
// Prefer importing from `theme` for new code.

import { theme } from "./theme";

export const SALMON_BACKGROUND_COLOR = theme.color.salmon;            // refined coral
export const BLUE_BACKGROUND_COLOR = theme.color.slate;               // refined slate
export const BLACK_FONT_COLOR = theme.color.text;                     // #1F2937
export const LIGHT_GRAY_BACKGROUND = theme.color.surfaceSunk;         // warm inset
export const LIGHT_GREEN_COLOR = theme.color.stepGreen;

export const NUMBER_01_COLOR = theme.color.stepBlue;
export const NUMBER_02_COLOR = theme.color.stepGreen;
export const NUMBER_03_COLOR = theme.color.salmon;
export const QUESTION_MARK_COLOR = theme.color.stepGray;

export const WHITE = theme.color.surface;
export const ERROR_RED = theme.color.error;
export const SUCCESS_GREEN = theme.color.success;
export const WARNING_YELLOW = theme.color.warning;
export const CARD_TITLE_COLOR = theme.color.slate;
export const DARK_GRAY_TEXT = theme.color.text;
export const SECTION_TWO_BG = "#384B49";  // slightly richer than old #3d4f4d
export const PRICE_DISPLAY_RED = theme.color.priceAccent;
